// extracted by mini-css-extract-plugin
module.exports = {"container":"JV","imgContainer":"KV","content":"LV","brand":"MV","product":"NV","price":"OV","noLink":"PV"};